import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

function ListGroup(props) {
  const { children, type, position, className } = props;

  return (
    <div className={className}>
      <ul className={cx(`list-${type}`, `list-${position}`)}>{children}</ul>
    </div>
  );
}

ListGroup.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  type: PropTypes.oneOf(["disc", "decimal", "none"]),
  position: PropTypes.oneOf(["inside", "outside"]),
  className: PropTypes.string,
};

ListGroup.defaultProps = {
  type: "disc",
  position: "inside",
  className: "",
};

export default ListGroup;
